import { Link } from "react-router-dom";
import s from "./PublicUserBadge.module.css";

function getUser() {
  try {
    return JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user") || "null");
  } catch { return null; }
}

/**
 * Public-navbar auth control.
 * When logged in: avatar + name + role → /dashboard.
 * When logged out: "Log In" link → /login.
 *
 * Pass variant="dark" when the surrounding bar has a dark background
 * (news detail, program detail). Default "light" is for the homepage navbar.
 */
export default function PublicUserBadge({ variant = "light", compact = false }) {
  const user = getUser();

  if (!user) {
    return (
      <Link to="/login" className={`${s.loginLink} ${variant === "dark" ? s.loginLinkDark : ""}`}>
        Log In
      </Link>
    );
  }

  const displayName = user.employeeName || user.linkedEntity?.displayName || user.username;
  const photoUrl    = user.photoUrl    || user.linkedEntity?.photoUrl    || "";
  const initial = (displayName || "?")[0].toUpperCase();

  return (
    <Link
      to="/dashboard"
      className={`${s.chip} ${variant === "dark" ? s.chipDark : ""} ${compact ? s.chipCompact : ""}`}
      title="Go to dashboard">
      {photoUrl
        ? <img src={photoUrl} alt={displayName} className={s.avatar} />
        : <div className={s.avatarFallback}>{initial}</div>
      }
      {!compact && (
        <div className={s.meta}>
          <div className={s.name}>{displayName}</div>
          <div className={s.role}>{user.role}</div>
        </div>
      )}
    </Link>
  );
}
